import React, { useState } from "react";
import { Document, Page } from "react-pdf/dist/esm/entry.webpack";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import samplePDF from "./Aishani_Resume.pdf";
import "./resume.css";
import linkedin from "../../images/Linked.png";
import mail from "../../images/Mail.png";
import linkk from "../../images/linkk.png";
// import coffee from "../../images/Coffee.png";

function Resumepdf() {
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }
  return (
    <div className="wrap">
      <div className="header">
        Resume.
        <p className="creds">
          Here is my resume. Summing up my work here.<br></br>But my creativity
          is beyond this :').
        </p>
      </div>

      <div className="resumeBody">
        <div className="pdf">
          {/* <div className="resHeader">
            <div className="resLeft">
              <div className="style1">Aishani Pachauri</div>
              <a className="style3" href="https://aishanipach.netlify.app/">
                https://aishanipach.netlify.app/
              </a>
            </div>
          </div> */}

          <div className="resEdu">
            <div className="style2">EDUCATION</div>
            <hr></hr>

            <div className="element">
              <div className="style2sub">
                <ul>
                  <li>Jaypee University of Information Technology</li>
                </ul>
              </div>

              <div className="smallstyle">
                &emsp;&emsp;Solan, JUL 2019 - JUL 2023
              </div>
              <div className="resDescr">
                &emsp;&emsp;    Bachelors of Technology in Computer Science; GPA:
                8.4 (/10.0)
              </div>
            </div>

            <div className="element">
              <div className="style2sub">
                <ul>
                  <li>Delhi Public School</li>
                </ul>
              </div>

              <div className="smallstyle">
                &emsp;&emsp;Delhi, MAR 2017 - MAR 2019
              </div>
              <div className="resDescr">
                &emsp;&emsp;AISSCE; Percentage:88% (/100%)
              </div>
            </div>
          </div>
          <br />
          <br />
          <div className="resEdu">
            <div className="style2">EXPERIENCE</div>
            <hr></hr>
            <div className="element">
              <div className="style2sub">
                <ul>
                  <li>Javascript Developer- Electorq</li>
                </ul>
              </div>

              <div className="smallstyle">&emsp;&emsp;JAN 2022 - JUN 2022</div>
              <div className="resDescr">
                &emsp;&emsp;Developed ReactJS based dashboard for distribution
                and inventory of the product.Written efficient AWS Cloud Lambdas
                <br />
                &emsp;&emsp;in Node.js and configured Rest APIs for backend
                integration of the platform
              </div>
            </div>

            <div className="element">
              <div className="style2sub">
                <ul>
                  <li>Marketing Analyst- Fundamento.ai</li>
                </ul>
              </div>

              <div className="smallstyle">&emsp;&emsp;APR 2021 - JUN 2021</div>
              <div className="resDescr">
                &emsp;&emsp;Worked on various pipelines to increase traffic to
                the web portal through social media channels and formulated
                campaign<br />
                &emsp;&emsp;to help recruiters find best candidates amidst the
                pandemic
              </div>
            </div>
          </div>
          <br />
          <br />
          <div className="resPro">
            <div className="style2">PROJECTS</div>
            <hr></hr>
            <div className="element">
              <div className="style2sub">
                <ul>
                  <li>
                    <a href="https://covid-19-app-2633a.web.app/">
                      Covid Dashboard
                    </a>
                  </li>
                </ul>
              </div>

              <div className="smallstyle">
                &emsp;&emsp;REACT, MATERIALUI, LEAFLET API
              </div>
              <div className="resDescr">
                &emsp;&emsp;React based dashboard to showcase live worldwide and
                country-specific COVID-19 infected cases.
                <br />
                &emsp;&emsp;Fetching real time data from{" "}
                <a href="https://disease.sh/">disease.sh</a> open API.
              </div>
            </div>

            <div className="element">
              <div className="style2sub">
                <ul>
                  <li>
                    <a href="https://github.com/Aishanipach/PictureinPicture">
                      Miniplay
                    </a>
                  </li>
                </ul>
              </div>

              <div className="smallstyle">
                &emsp;&emsp;JS, RESTFUL APIs, CHROME EXTENSION
              </div>
              <div className="resDescr">
                &emsp;&emsp;A simple chrome extension for picture in picture
                experience across all applications in Javascript.
                <br />
                &emsp;&emsp;Utilising various rest APIs like Capture and picture
                in picture API.
              </div>
            </div>
            <div className="element">
              <div className="style2sub">
                <ul>
                  <li>
                    <a href="https://github.com/Aishanipach/Data-Visualizer">
                      Data Visualizer
                    </a>
                  </li>
                </ul>
              </div>

              <div className="smallstyle">
                &emsp;&emsp;JS, RESTFUL APIs, CHROME EXTENSION
              </div>
              <div className="resDescr">
                &emsp;&emsp;A calendar-based dashboard made using React.js to
                process and compare data entered. Based on a minimal UX, helps
                <br /> &emsp;&emsp;in maintaining a list and visualizing
                quantified data using Recharts. Useful for budget planning,
                Logging expenditure.
                <br /> &emsp;&emsp;Utilising various rest APIs like Capture and
                picture in picture API.
              </div>
            </div>
            <div className="element">
              <div className="style2sub">
                <ul>
                  <li>
                    <a href="https://medium.com/acm-juit/how-to-get-started-arfoundation-in-unity-f0a050b3585f">
                      Miniplay
                    </a>
                  </li>
                </ul>
              </div>

              <div className="smallstyle">
                &emsp;&emsp;JS, RESTFUL APIs, CHROME EXTENSION
              </div>
              <div className="resDescr">
                &emsp;&emsp;Augmented Reality android app to augment 3-D models
                of architectures on different terrain using ARCore SDK by Google
                to
                <br /> &emsp;&emsp;deploy plane detection along with
                ARFoundation built on Unity Engine. The app helps present civil
                models in pre-planning stage
                <br />
                &emsp;&emsp;to enhance design. Currently writing a research
                paper on same for Springer publication. Useful for budget
                planning,
                <br /> &emsp;&emsp;Logging expenditure. Utilising various rest
                APIs like Capture and picture in picture API.
              </div>
            </div>
          </div>
          <br />
          <br />
        </div>
        {/* <div className="pdf-container">
          <Document file={samplePDF} onLoadSuccess={onDocumentLoadSuccess}>
            <Page pageNumber={pageNumber} />
          </Document>
          <p>
            Page {pageNumber} of {numPages}
          </p>
        </div> */}

        <div className="fixed-icons">
          <ul id="float-icons" className="icons">
            <li className="resume-icons">
              <a
                className="icon-links"
                href="https://www.linkedin.com/in/aishanipachauri/"
                target="_blank"
                id="icon1"
              >
                <img className="img-icons" src={linkedin} alt="link" />
              </a>
            </li>
            <li className="resume-icons">
              <a
                className="icon-links"
                href="mailto:aishani.pachauri@gmail.com"
                target="_blank"
                id="icon2"
              >
                <img className="img-icons" src={mail} id="icon2" alt="email" />
              </a>
            </li>
            <li className="resume-ions">
              <a
                className="icon-links"
                href="https://drive.google.com/file/d/1nGlXBqDXwUl505rhN27Bco569cRMhKpR/view?usp=sharing"
                target="_blank"
                id="icon1"
              >
                <img className="img-ions" src={linkk} alt="link" />
              </a>
            </li>
          </ul>
          {/* <img src={coffee} id="coffee" alt="coffee"></img> */}
        </div>
      </div>
    </div>
  );
}
export default Resumepdf;
